import React from 'react';

import { useRecoilValue } from 'recoil';

import { blockDateRange, blockDisplayHeader, blockSubHeader } from 'venn-state';

import { Block } from '../../components/core';

import { DefaultDateRange } from '../../components/secondary/date-ranges';

import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';

interface HistoricalAllocationsTimeSeriesHeaderProps {
  id: string;
}

export const HistoricalAllocationsTimeSeriesHeader = ({ id }: HistoricalAllocationsTimeSeriesHeaderProps) => {
  const title = useRecoilValue(blockDisplayHeader(id));
  const subHeader = useRecoilValue(blockSubHeader(id));
  const dateRange = useRecoilValue(blockDateRange(id));

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
        </Block.Title>

        <Block.Metadata id={id}>
          <DefaultDateRange dateRange={dateRange} />
        </Block.Metadata>
      </Block.HeaderTopContainer>

      <DefaultSubjects id={id} relativeToBenchmark={false} forceShowSubjects />
    </>
  );
};
